export const enum MessagingChannels {
  SendFiles = 'sendFiles',
  ChangeUploadBtnStatus = 'changeUploadBtnStatus',
}
